// Shimmering Prism — post-process vertex shader (RawShaderMaterial, GLSL ES 1.00 / WebGL1).
//
// Fullscreen quad: PlaneBufferGeometry(2,2) rendered with the same orthographic camera as the
// background quad. RawShaderMaterial does not auto-inject declarations, so the built-in
// modelViewMatrix / projectionMatrix uniforms and the position + uv attributes are declared
// explicitly; Three.js still binds their values by name. `vUv` (0..1) samples the render target.
export default `
precision highp float;

uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

attribute vec3 position;
attribute vec2 uv;

varying vec2 vUv;

void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}
`;
